function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import findNodeIn, { findPMNode } from "../utils/find-node";
import { editorStateAtom } from "./editor-state";
import { expandPathAtom } from "./expand-path";
var NODE_PICKER_DEFAULT = {
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  active: false
};
var nodePickerAtom = atom(NODE_PICKER_DEFAULT);

// TODO: rewrite as read and write atom
export function useNodePicker() {
  var _useAtom = useAtom(nodePickerAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    nodePickerState = _useAtom2[0],
    setNodePickerState = _useAtom2[1];
  var editorState = useAtomValue(editorStateAtom);
  var setExpandPath = useSetAtom(expandPathAtom);
  var api = {
    activate: function activate() {
      setNodePickerState(_objectSpread(_objectSpread({}, NODE_PICKER_DEFAULT), {}, {
        active: true
      }));
    },
    deactivate: function deactivate() {
      setNodePickerState(NODE_PICKER_DEFAULT);
    },
    select: function select(target) {
      if (!editorState) return;
      var node = findPMNode(target);
      if (node) {
        var path = findNodeIn(editorState.doc, editorState.doc.nodeAt(node.pmViewDesc.posAtStart));
        if (!path) return;
        setExpandPath([]);
        setExpandPath(path);
        api.deactivate();
      }
    },
    updatePosition: function updatePosition(target) {
      var node = findPMNode(target);
      if (node && (node.pmViewDesc.node && node.pmViewDesc.node.type.name !== "doc" || node.pmViewDesc.mark)) {
        var _node$getBoundingClie = node.getBoundingClientRect(),
          top = _node$getBoundingClie.top,
          left = _node$getBoundingClie.left,
          width = _node$getBoundingClie.width,
          height = _node$getBoundingClie.height;
        setNodePickerState({
          top: top + window.scrollY,
          left: left,
          width: width,
          height: height,
          active: true
        });
      } else {
        api.activate();
      }
    }
  };
  return [nodePickerState, api];
}